import { Pipe, PipeTransform } from '@angular/core';
import { ADMIN, AuthGuard, SUPER_ADMIN, VIEWER } from '../../common/auth-guard.service';
import { LoggedUser, User } from '../../common/logged-user.service';

@Pipe({
  name: 'userHasRole'
})
export class UserHasRolePipe implements PipeTransform {

  validRoles: string[];
  user: User;

  constructor(private authGuard: AuthGuard,
              private loggedUser: LoggedUser) {
    this.validRoles = ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_OPERATOR', 'ROLE_VIEWER'];
    loggedUser.userObservable.subscribe(user => this.user = user);
  }

  transform(value: string, allowOrgUsers: boolean = true): boolean {
    if (this.user) {
      if (this.authGuard.minRole('ROLE_SUPER_ADMIN')) {
        return true;
      }
      if (!allowOrgUsers && this.user?.organizationUuid) {
        return false;
      }
      return this.hasMinimumRole(value);
    } else {
      return false;
    }
  }

  hasMinimumRole(value: string): boolean {
    if (this.validRoles.includes(value)) {
      return this.authGuard.minRole(value);
    }
    return false;
  }

}
